import React from 'react'

import Image, { ImageProps } from 'components/_new/ui/Image/Image'

import placeholder from './images/placeholder.jpg'


type PlaceholderImageProps = Omit<ImageProps, 'src' | 'srcSet'>


const PlaceholderImage: React.FunctionComponent<PlaceholderImageProps> = (props) => (
  <Image
    {...props}
    src={placeholder}
    srcSet={undefined}
  />
)


export default PlaceholderImage
